import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { omitBy } from 'lodash';
import classnames from 'classnames';
import Select from 'react-select';
import { isEmail } from 'validator';

import firebase from '../../firebase';

const { keys } = Object;
const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const defaultState = {
  id: null,
  name: '',
  validations: {},
  isSubmitting: false,
};
const { entries } = Object;

export default class TableFormModal extends Component {
  constructor() {
    super();
    this.state = { ...defaultState };
  }
  componentDidUpdate(prevProps, prevState) {
    if(!prevProps.isOpen && this.props.isOpen) {
      this.clear();
      this.setValues();
    }
  }
  clear() {
    this.setState({ ...defaultState });
  }
  setValues() {
    const { values } = this.props;
    this.setState({ ...omitBy(values, _ => _ === undefined) });
    entries(values || {}).forEach(([k, v]) => setTimeout(() => this.validate(k, v), 0));
  }
  validate = (propName, value) => {
    const { validations } = this.state;
    switch (propName) {
      case 'name': 
        this.setState({ validations: { ...validations, [propName]: !!value } });
        break;
      default:
        this.setState({ validations: { ...validations, [propName]: true } });
        break;
    }
  }
  validationCss(name) {
    const { validations: { [name]: isValid } } = this.state;
    return classnames({ 'is-valid': isValid, 'is-invalid': isValid === false });
  }
  onChange = (name, { target: { value } }) => {
    this.validate(name, value);
    this.setState({ [name]: value });
  }
  onMultiSelect = (name, selectedOptions) => {
    const value = selectedOptions.reduce((x, y) => ({ ...x, [y.value]: true }), {});
    this.validate(name, value);
    this.setState({ [name]: value });
  }
  onSubmit = (event) => {
    event.preventDefault();
    if(this.isUnsubmittable()) return;
    const { onSubmit } = this.props;
    const { id, name, tables, } = this.state;
    this.setState({ isSubmitting: true });
    onSubmit({ id, name, tables, });
  }
  isUnsubmittable() {
    const { isSubmitting, validations } = this.state;
    return isSubmitting || ['name'].some(_ => !validations[_]);
  }
  render() {
    const { isOpen, tables: _tables, onClickClose } = this.props;
    const { id, name, tables = {}, } = this.state;
    const isNew = !id;
    const tableOptions = (_tables || []).map(_ => ({ label: _.name, value: _.id }));
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>
          {isNew ? '新規結合可能テーブル群' : '結合可能テーブル群編集'}
        </ModalHeader>
        <Form onSubmit={this.onSubmit}>
          <ModalBody>
            <FormGroup>
              <Label>結合可能テーブル群名</Label>
              <Input value={name} onChange={this.onChange.bind(this, 'name')} className={this.validationCss('name')} disabled={!isNew} />
            </FormGroup>
            <FormGroup>
              <Label>テーブル</Label>
              <Select
                value={tableOptions.filter(_ => keys(tables).includes(_.value))}
                onChange={this.onMultiSelect.bind(this, 'tables')}
                options={tableOptions}
                isMulti
                isClearable={false}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={onClickClose}>Cancel</Button>
            <Button type="submit" color="primary" onClick={this.onSubmit} disabled={this.isUnsubmittable()}>保存</Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
};
